<template>
  <img :src="fileIcon" alt="">
</template>

<script>

import {getFileIcon, getFileType} from "@/common/util";

export default {
  name: 'file-icon',
  props: {
    type: {
      default: 1,
    },
    fileName: {
      default: '',
    },
  },
  computed: {
    fileType() {
      let fileType = '';
      if (this.type === 2) {
        fileType = 'folder';
      } else {
        fileType = getFileType(this.fileName || '');
      }
      return fileType;
    },
    fileIcon() {
        return getFileIcon(`${this.fileType}_bg`);
    },
  }
}
</script>
